import { DailyReportInterface } from 'types';
import { DAILY_REPORTS_REQUESTED, DAILY_REPORTS_SUCCESS, DAILY_REPORTS_FAILED } from './constants';
import { Action } from '../useReducerWithMiddleware';

export type DailyReportsState = {
    loading: boolean;
    errorMessage: string;
    reports: DailyReportInterface | null;
};

export const initialDailyReportsState: DailyReportsState = {
    loading: false,
    errorMessage: '',
    reports: null,
};

export default function dailyReportsReducer(
    state: DailyReportsState = initialDailyReportsState,
    action: Action
): DailyReportsState {
    switch (action.type) {
        case DAILY_REPORTS_REQUESTED:
            return {
                ...state,
                loading: true,
                errorMessage: '',
            };
        case DAILY_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                errorMessage: '',
                reports: (action.payload as { reports: DailyReportInterface }).reports,
            };
        case DAILY_REPORTS_FAILED:
            return {
                ...state,
                loading: false,
                errorMessage: (action.payload as { message: string }).message,
            };
        default:
            return state || initialDailyReportsState;
    }
}
